import { Link } from 'react-router-dom';

export default function AboutIntro() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="w-full lg:w-[45%]">
            <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider font-label">About CSSBuy Sheet</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight tracking-tight mt-4 mb-5">
              Your Trusted Source for Proxy Shopping Spreadsheets
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 font-body">
              If you&rsquo;re looking for the most reliable <strong>CSSBuy spreadsheet</strong>, you&rsquo;re in the right place. We collect, compare, and organize the best proxy shopping spreadsheets for CSSBuy spreadsheet (most popular), Kakobuy spreadsheet (fast-growing alternative), Superbuy spreadsheet (premium agent option), and Oopbuy spreadsheet (budget-friendly option).
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 font-body">
              Our goal is to help you find better products, lower shipping costs, and safer buying methods. Every spreadsheet is verified and updated weekly to ensure accuracy.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer font-label"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <Link
                to="/article/best-cssbuy-spreadsheet-guide-2026"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 text-sm font-medium rounded-full hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer font-label border border-background-200/70"
              >
                Read Full Guide
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
            </div>
          </div>

          <div className="w-full lg:w-[55%] flex gap-4 items-end">
            <div className="w-[40%] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20editorial%20shot%20of%20a%20curated%20fashion%20mood%20board%20with%20fabric%20swatches%20polaroid%20photos%20and%20dried%20botanicals%20pinned%20on%20cork%20board%20surface%2C%20warm%20ambient%20lighting%20from%20nearby%20window%2C%20creative%20styling%20with%20soft%20terracotta%20sage%20green%20and%20cream%20tones%2C%20artistic%20studio%20aesthetic%20with%20organic%20layered%20composition&width=600&height=800&seq=about-img-left-v3&orientation=portrait"
                alt="CSSBuy spreadsheet lifestyle"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-[60%] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimal%20workspace%20with%20laptop%20on%20standing%20desk%20beside%20a%20pegboard%20wall%20with%20organized%20tools%20and%20notes%2C%20natural%20morning%20light%20flooding%20through%20large%20window%20with%20sheer%20curtains%2C%20indoor%20potted%20monstera%20plant%20adding%20organic%20greenery%2C%20calm%20productive%20atmosphere%2C%20modern%20scandinavian%20inspired%20interior%20with%20warm%20wood%20and%20cream%20tones&width=1000&height=750&seq=about-img-right-v3&orientation=landscape"
                alt="Proxy shopping spreadsheet workspace"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}